package com.vamvisions.main.portfolio.data.mapper

import com.vamvisions.main.api.portfolio.DocumentDto
import com.vamvisions.main.api.portfolio.ExperienceDto
import com.vamvisions.main.api.portfolio.ExperienceSectionDto
import com.vamvisions.main.api.portfolio.ProjectDto
import com.vamvisions.main.api.portfolio.ProjectStatusDto
import com.vamvisions.main.api.portfolio.SkillDto
import com.vamvisions.main.api.portfolio.StoreDto
import com.vamvisions.main.api.portfolio.StoreLinkDto
import com.vamvisions.main.core.domain.preferences.Language
import com.vamvisions.main.portfolio.domain.model.Document
import com.vamvisions.main.portfolio.domain.model.Experience
import com.vamvisions.main.portfolio.domain.model.ExperienceSection
import com.vamvisions.main.portfolio.domain.model.PartialDate
import com.vamvisions.main.portfolio.domain.model.Project
import com.vamvisions.main.portfolio.domain.model.ProjectStatus
import com.vamvisions.main.portfolio.domain.model.Skill
import com.vamvisions.main.portfolio.domain.model.Store
import com.vamvisions.main.portfolio.domain.model.StoreLink
import com.vamvisions.main.api.portfolio.PartialDate as PartialDateDto

fun SkillDto.toSkill(): Skill = Skill(slug = slug, name = name, description = description, url = url)

fun PartialDateDto.toPartialDate(): PartialDate = PartialDate(year = year, month = month)

fun ExperienceSectionDto.toExperienceSection(): ExperienceSection = when (this) {
    ExperienceSectionDto.TIMELINE -> ExperienceSection.TIMELINE
    ExperienceSectionDto.LEARNING -> ExperienceSection.LEARNING
    ExperienceSectionDto.EDUCATION -> ExperienceSection.EDUCATION
}

fun StoreDto.toStore(): Store = when (this) {
    StoreDto.GOOGLE_PLAY -> Store.GOOGLE_PLAY
    StoreDto.APP_STORE -> Store.APP_STORE
}

fun ProjectStatusDto.toProjectStatus(): ProjectStatus = when (this) {
    ProjectStatusDto.PUBLISHED -> ProjectStatus.PUBLISHED
    ProjectStatusDto.COMING_SOON -> ProjectStatus.COMING_SOON
}

fun StoreLinkDto.toStoreLink(): StoreLink = StoreLink(store = store.toStore(), url = url)

fun ProjectDto.toProject(): Project = Project(
    slug = slug,
    name = name,
    description = description,
    year = year,
    status = status.toProjectStatus(),
    featured = featured,
    meta = meta,
    iconUrl = iconUrl,
    storeLinks = storeLinks.map { it.toStoreLink() },
    websiteUrl = websiteUrl,
    sourceUrl = sourceUrl,
    privacyPolicySlug = privacyPolicySlug,
    skills = skills.map { it.toSkill() },
)

fun ExperienceDto.toExperience(): Experience = Experience(
    slug = slug,
    section = section.toExperienceSection(),
    name = name,
    role = role,
    highlights = highlights,
    start = start.toPartialDate(),
    end = end?.toPartialDate(),
    url = url,
    skills = skills.map { it.toSkill() },
)

/** [requested] is used when the server reports a language code this client doesn't know. */
fun DocumentDto.toDocument(requested: Language): Document = Document(
    slug = slug,
    language = Language.fromCode(lang) ?: requested,
    title = title,
    markdown = markdown,
    updatedAt = updatedAt,
)
